module.exports = __webpack_public_path__ + "static/media/logo-papelzero-negativo.a3e59da8.svg";